<script>
import resources from './resources'

export default {
  name: 'professional-agendas-index',
  mixins: [resources]
}
</script>

<template lang="pug">
page(title="Cadastro de Agenda Profissional", icon="")
  .col-xs-12.content
    .container-fluid
      .row
        medibook-alert-custom(
          :show='show',
          @close='show = false',
          message='Ainda não existe nenhum Local de Atendimento cadastrado',
          :buttonsNext='nextStepButtonAddress',
          v-if="!statusAddress")

        medibook-alert-custom(
          :show='show',
          @close='show = false',
          message='Ainda não existe nenhum Honorário cadastrado',
          :buttonsNext='nextStepButtonPrices',
          v-if="statusAddress && !statusPrice")

        ul.nav.nav-tabs
          li.active
            a(href="#") Listagem

          li(v-if="!statusAddress")
            a.mb-cursor-point(@click.prevent="show = true")
             | Cadastro

          li(v-if="statusAddress && !statusPrice")
            a.mb-cursor-point(@click.prevent="show = true")
             | Cadastro

          li(v-if="statusAddress && statusPrice")
            router-link(:to="{name: 'professional.agenda.agendas.create'}")
             a(href='#') Cadastro

        .col-xs-12.white-bg.wrapper(v-if="loading")
          .row.border-bottom-light
            spinner(:show="true")
        .col-xs-12.white-bg.wrapper(v-if="!loading")
          .row.border-bottom-light
            .col-sm-offset-9.col-sm-3
              form.col-sm-12
                .form-group.busca(style='margin-top:30px;')
                  .row
                    .col-xs-9
                      input#buscar.form-control(v-model="search.generic", type='text', placeholder='Buscar Agendas')
                    .col-xs-3
                      button.search(@click.prevent="doLoadAll()")
                        span.icon 

            a.mb-cursor-point(v-if="!statusAddress && !statusPrice", @click.prevent="show = true")
              .add-list.mb-cursor-point
                .icon-wrapper
                  span.icon 
                  .plus
                    span.icon 
                .text
                  | Nova<br>Agenda profissional

            a.mb-cursor-point(v-if="statusAddress && !statusPrice", @click.prevent="show = true")
              .add-list.mb-cursor-point
                .icon-wrapper
                  span.icon 
                  .plus
                    span.icon 
                .text
                  | Nova<br>Agenda profissional

            card-add(label='Nova<br>Agenda Profissional', route='professional.agenda.agendas.create', icon='', v-if="statusAddress && statusPrice")

            .list-item.white-bg.list-item(v-for=("agenda in agendas"))
              .row.border-bottom
                h4.col-xs-8(v-tooltip="agenda.name") {{ agenda.name_small }}
                .col-xs-4
                  .exclude-list(@click.prevent="doDeleteNextSetp(agenda)")
                    span.icon 
                  router-link(:to="{name: getRouterEdit, params: {id: agenda.id, professional: agenda.professional_id}}")
                    a(href='#')
                      .edit-list
                        span.icon 
              .list-info
                strong(v-for="speciality in agenda.specialities", :key="speciality.id")
                  | {{ speciality.name }},
                br
                small {{ agenda.address.name }}
                br
                strong
                  i {{ agenda.professional.name }}
                br
                .badge.badge-light.pull-right(v-tooltip="'Regras Ativas'")
                  router-link(:to="{name: 'professional.agenda.rules.index'}")
                    |{{ agenda.countrules }}
          .pagination
            pagination(:pagination="pagination", @pagination-changed-page="setPage")
</template>



// WEBPACK FOOTER //
// src/app/professional/agenda/agendas/index/index.vue